var map = {
	"./en-us.json": [
		"../localization/src/translations/platform/en-us.json",
		"default-localization_src_translations_platform_en-us_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "../localization/src/translations/platform lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;